@if (activeQuestion$()) {
  <div [formGroup]="activeQuestion$()" class="dropdown-settings__container">
    <div class="dropdown-settings__input-containers">
      <empathy-required-setting [activeQuestion]="activeQuestion$()"></empathy-required-setting>
      <empathy-randomized-options-setting [activeQuestion]="activeQuestion$()"></empathy-randomized-options-setting>
      <empathy-min-view-time-setting [activeQuestion]="activeQuestion$()" [showBorder]="false"></empathy-min-view-time-setting>
    </div>
    <empathy-media-settings [activeQuestion]="surveyEditorService.surveyEditor$().activeQuestion"></empathy-media-settings>
    <empathy-choice-settings [activeQuestion]="activeQuestion$()"></empathy-choice-settings>
  </div>
}
